import { render, staticRenderFns } from "./MenuStaff.vue?vue&type=template&id=cd7bca4c&"
import script from "./MenuStaff.vue?vue&type=script&lang=js&"
export * from "./MenuStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports